import { render, staticRenderFns } from "./FooterTwo.vue?vue&type=template&id=95117272"
import script from "./FooterTwo.vue?vue&type=script&lang=js"
export * from "./FooterTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports